<a
  class="relative w-[220px] flex h-[180px] justify-center rounded-3xl text-white"
>
  <img
    class="absolute object-cover w-full h-full rounded-3xl brightness-50"
    [src]="image()"
    alt=""
    srcset=""
  />
  <div class="absolute w-full h-[180px] flex flex-col justify-between p-5">
    <div class="flex w-full justify-end items-end">
      @if (badgeData) {
      <ui-badge [color]="'orange'" [badgeText]="badgeData"></ui-badge>
      }
    </div>

    <div class="flex z-10 flex-col items-start">
      <h1>{{ title() }}</h1>
      <span>{{ description() }}</span>
      <span class="font-light line-through">{{ altDescription() }}</span>
    </div>
  </div>
</a>
